import { careers, whatsappUrl } from "../mock";
import { Award, TrendingUp, Trophy, Infinity as InfinityIcon, Users } from "lucide-react";

export default function Career() {
  return (
    <section className="py-20 dark-green-section">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <div className="text-center">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-emerald-500/30 bg-emerald-500/10 text-emerald-400 text-xs font-semibold mb-4">
            Plano de Carreira
          </div>
          <h2 className="text-white text-3xl md:text-5xl font-extrabold leading-tight">
            Construa um <span className="gold-gradient-text">Legado Financeiro</span>
          </h2>
          <p className="mt-5 text-slate-300 max-w-2xl mx-auto">
            Na iGreen, você não apenas constrói uma renda — você constrói um patrimônio que pode ser passado de geração em geração.
          </p>
        </div>

        <div className="mt-12 grid md:grid-cols-2 gap-5">
          <div className="rounded-2xl border border-emerald-500/20 bg-white/[0.03] p-6">
            <div className="flex items-center gap-3">
              <InfinityIcon className="w-6 h-6 text-emerald-400" />
              <h3 className="text-white font-bold text-xl">Comissões Vitalícias</h3>
            </div>
            <p className="mt-3 text-slate-300 text-sm leading-relaxed">
              Seus clientes geram comissões para você <b className="text-white">enquanto permanecerem ativos</b>. Um cliente captado hoje pode render por 5, 10, 20 anos ou mais.
            </p>
            <ul className="mt-4 space-y-2 text-sm text-slate-300">
              <li>• Renda passiva real e crescente</li>
              <li>• Sem necessidade de renovação ou retrabalho</li>
              <li>• Acumule clientes e multiplique seus ganhos</li>
            </ul>
          </div>
          <div className="rounded-2xl border border-amber-500/20 bg-white/[0.03] p-6">
            <div className="flex items-center gap-3">
              <Users className="w-6 h-6 text-amber-400" />
              <h3 className="text-white font-bold text-xl">Comissões Hereditárias</h3>
            </div>
            <p className="mt-3 text-slate-300 text-sm leading-relaxed">
              Seu trabalho não termina com você. <b className="text-white">Seus herdeiros podem continuar recebendo</b> suas comissões, transformando sua dedicação em legado familiar.
            </p>
            <ul className="mt-4 space-y-2 text-sm text-slate-300">
              <li>• Transferência de carteira para herdeiros</li>
              <li>• Segurança financeira para sua família</li>
              <li>• Patrimônio que atravessa gerações</li>
            </ul>
          </div>
        </div>

        <div className="mt-12">
          <h3 className="text-white text-2xl font-bold text-center mb-8 flex items-center justify-center gap-2">
            <TrendingUp className="w-5 h-5 text-emerald-400" /> Níveis de Carreira
          </h3>
          <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-4">
            {careers.map((c, i) => (
              <div
                key={c.name}
                className={`rounded-2xl border p-5 backdrop-blur-sm transition-transform hover:-translate-y-1 ${
                  i === careers.length - 1
                    ? "border-amber-400/50 bg-gradient-to-b from-amber-500/10 to-transparent"
                    : "border-emerald-500/20 bg-white/[0.03]"
                }`}
              >
                <div className="flex items-center gap-2 text-amber-300 mb-3">
                  <Award className="w-4 h-4" />
                  <span className="font-bold">{c.name}</span>
                </div>
                <div className="space-y-2 text-xs text-slate-300">
                  <div className="flex justify-between"><span>Meta</span><span className="text-white font-semibold">{c.meta}</span></div>
                  <div className="flex justify-between"><span>Comissão</span><span className="text-emerald-400 font-semibold">{c.comissao}</span></div>
                  <div className="flex justify-between"><span>Bônus Telecom</span><span className="text-white font-semibold">{c.telecom}</span></div>
                  <div className="flex justify-between"><span>Bônus Licenciado</span><span className="text-white font-semibold">{c.bonus}</span></div>
                </div>
                {c.premio && (
                  <div className="mt-4 pt-4 border-t border-white/10">
                    <div className="flex items-center gap-2 text-amber-400 text-xs font-semibold mb-1"><Trophy className="w-3.5 h-3.5" /> Premiação</div>
                    <p className="text-slate-300 text-xs leading-relaxed">{c.premio}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
          <div className="mt-10 text-center">
            <h4 className="text-white font-bold text-xl">Seu sucesso é recompensado em cada etapa</h4>
            <p className="text-slate-300 max-w-2xl mx-auto mt-2">
              Quanto mais você cresce, maiores são suas comissões, bônus e prêmios. Construa sua carreira e conquiste viagens incríveis ao redor do mundo!
            </p>
            <a href={whatsappUrl} target="_blank" rel="noreferrer" className="btn-gold inline-flex items-center gap-2 px-6 py-3 rounded-xl text-sm mt-6">
              Chamar no WhatsApp
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
